const objModalSizes = {
  small: 'modal-sm',
  large: 'modal-lg',
  extra: 'modal-xl',
}

const ModalContentAux = ({
  content,
  title = '',
  idModal = 'defaultModalId',
  classModalDialog = 'modal-dialog-scrollable modal-dialog-centered',
  size = null,
  showFooter = true,
  onClose = () => {},
  onAccept = () => {},
  showBtnCloseHeader = true,
  showBtnAcceptFooter = true,
  textBtnCancelFooter = 'Cancelar',
  showfooterContet = '',
}) => {
  const sizeModal = size ? objModalSizes[size] : ''

  const btnCloseModal = () => {
    window.jQuery('#' + idModal).modal('hide')
    onClose()
  }

  const btnAccept = () => {
    window.jQuery('#' + idModal).modal('hide')
    onAccept()
  }

  return (
    <div
      className="modal fade"
      data-backdrop="static"
      data-keyboard="false"
      id={idModal}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={`${idModal}Title`}
      aria-hidden="true"
    >
      <div
        className={`modal-dialog ${classModalDialog} ${sizeModal}`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            {showBtnCloseHeader && (
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={btnCloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            )}
          </div>
          <div className="modal-body">{content}</div>
          {showFooter && (
            <div className="modal-footer">
              {showfooterContet === '' ? (
                <>
                  {showBtnAcceptFooter && (
                    <button
                      type="button"
                      className="btn POS-btnEnfasis1 text-white mr-3"
                      onClick={btnAccept}
                    >
                      Aceptar
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn POS-btnOnlyBorder"
                    onClick={btnCloseModal}
                  >
                    {textBtnCancelFooter}
                  </button>
                </>
              ) : (
                showfooterContet
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ModalContentAux
